/* TAB 2 — PICK. Hành vi y v4 (docs/02-CHUC-NANG.md), tầng ghi đổi:
   - quét MVĐ: tra RAM → hiện đơn NGAY; claim_pick gọi nền, máy khác đang mở thì báo vàng
   - quét mã vạch / sửa SL / thay thế: chỉ sửa RAM (+ nháp IndexedDB phòng đóng tab)
   - Hoàn thành: đổi RAM ngay, finish_pick vào hàng đợi nền
   - Nhặt lại: localResetPick + reset_pick vào hàng đợi
   - đơn không có trong RAM (XONG/HUY chưa tải): chờ claim_pick 1 vòng mạng rồi mở */
import * as K from '../core/index.js';
import { S, findByCode, itemView, statOf, upsertLocal, localFinishPick, localResetPick } from '../store.js';
import { rpc } from '../lib/supabase.js';
import { enqueue, uuid } from '../lib/queue.js';
import { $, esc, log, dialog, beep, flash, stamp, kvSet, kvGet, kvDel, diagErr } from '../lib/ui.js';

/* pk.cur = đơn đại diện; pk.batch = cả nhóm (phần tử đầu = pk.cur) */
const pk = { cur: null, batch: [], hist: [], claimSeq: 0 };
export function pkCurrent() { return pk.cur; }
export function pkOpenKeys() { return pk.cur ? (pk.batch.length ? pk.batch : [pk.cur]) : []; }

export function initTab2() {
  $('#pkScan').addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const v = K.norm(this.value).toUpperCase().replace(/[^0-9A-Z]/g, '');
    this.value = '';
    if (v) pkLookup(v);
  });
  $('#pkBc').addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const v = K.norm(this.value).toUpperCase();
    this.value = '';
    if (v) pkBarcode(v);
  });
  $('#pkDone').onclick = pkDone;
  $('#pkSkip').onclick = pkSkip;
}

export function pkEnter() {
  const ready = Object.keys(S.orders).length > 0;
  $('#pkEmpty').style.display = ready ? 'none' : '';
  $('#pkMain').style.display = ready ? '' : 'none';
  if (!ready) return;
  pkRefresh();
  if (!pk.cur) setTimeout(() => $('#pkScan').focus(), 80);
}

/* --- tiến độ: mẫu số = số đơn CAN_GIAO --- */
export function pkRefresh() {
  let need = 0, done = 0, extra = 0; const newOrders = [];
  const chan = { SHOPEE: { n: 0, d: 0 }, TIKTOK: { n: 0, d: 0 } };
  Object.values(S.orders).forEach((o) => {
    if (o.statusGroup === 'CAN_GIAO') { need++; chan[o.channel].n++; if (o.pickState === 'done') { done++; chan[o.channel].d++; } }
    else if (o.pickState === 'done') extra++;
    if (o.statusGroup === 'MOI') newOrders.push(o);
  });
  const pc = need ? Math.round(done / need * 100) : 0;
  $('#pkBar').style.width = pc + '%';
  $('#pkStats').innerHTML =
    '<div><b>' + done + '<span style="color:var(--ink3)">/' + need + '</span></b> <span>đơn cần giao</span></div>' +
    '<div><b class="mono" style="font-size:19px;color:var(--shopee)">' + chan.SHOPEE.d + '/' + chan.SHOPEE.n + '</b> <span>shopee</span></div>' +
    '<div><b class="mono" style="font-size:19px;color:var(--tiktok)">' + chan.TIKTOK.d + '/' + chan.TIKTOK.n + '</b> <span>tiktok</span></div>' +
    (extra ? '<div><b class="mono" style="font-size:19px;color:var(--warn)">+' + extra + '</b> <span>ngoài danh sách</span></div>' : '');
  $('#pkNote').textContent = pc + '%';
  $('#pkNewCard').style.display = newOrders.length ? '' : 'none';
  if (newOrders.length) {
    $('#pkNewList').innerHTML = newOrders.map((o) => '<div>' + esc(o.orderId) + ' · ' + o.channel + ' · ' + esc(o.statusRaw) + ' · ' + o.items.length + ' SP</div>').join('');
  }
}

function pkMsg(type, html) {
  $('#pkMsg').innerHTML = html ? '<div class="note ' + type + '"><span class="ic">' + ({ e: '✕', w: '!', s: '✓', i: 'i' }[type] || 'i') + '</span><div>' + html + '</div></div>' : '';
}

/* --- quét mã vận đơn --- */
async function pkLookup(v) {
  const { keys, viaOid } = findByCode(v);
  if (pk.cur) {                                   // đang mở đơn → gom đơn giống nhau (luôn bật)
    if (keys.length) return pkAddToBatch(keys.find((k) => S.orders[k].pickState !== 'done') || keys[0], viaOid);
    pkMsg('i', 'Không có trong danh sách đang xử lý — đang hỏi máy chủ…');
    try {
      const { data } = await rpc('claim_pick', { p_code: v });
      if (!data.found) { beep('err'); flash('bad'); pkMsg('e', 'Không tìm thấy <b>' + esc(v) + '</b> trên máy chủ.'); return; }
      upsertLocal(data.order);
      return pkAddToBatch(data.order.key, data.viaOrderId, data);
    } catch (e) { beep('err'); flash('bad'); pkMsg('e', 'Không tra được máy chủ: <b>' + esc(e.message) + '</b>.'); return; }
  }
  if (!keys.length) {
    // không có trong RAM: có thể là đơn XONG/HUY chưa tải — hỏi máy chủ 1 lần (~150 ms)
    pkMsg('i', 'Không có trong danh sách đang xử lý — đang hỏi máy chủ…');
    try {
      const { data, ms } = await rpc('claim_pick', { p_code: v });
      if (!data.found) {
        beep('err'); flash('bad');
        pkMsg('e', 'Không tìm thấy <b>' + esc(v) + '</b> — không khớp mã vận đơn lẫn mã đơn hàng nào trên máy chủ. Kiểm tra lại mã hoặc nạp file mới ở tab 1.');
        return;
      }
      upsertLocal(data.order);
      log('Đơn ' + data.order.orderId + ' tải từ máy chủ (' + ms + ' ms) — ngoài danh sách đang xử lý.', 'wr');
      if (data.viaOrderId) pkMsg('w', 'Khớp theo <b>mã đơn hàng</b> ' + esc(data.order.orderId) + '.');
      await pkOpen(data.order.key, v, data);
    } catch (e) {
      beep('err'); flash('bad');
      pkMsg('e', 'Không tra được máy chủ: <b>' + esc(e.message) + '</b>.');
    }
    return;
  }
  if (viaOid) {
    const oo = S.orders[keys[0]];
    pkMsg('w', 'Khớp theo <b>mã đơn hàng</b> ' + esc(oo.orderId) + (oo.tracking ? '' : ' — đơn này chưa có mã vận đơn (chưa Chuẩn bị hàng trên sàn)') + '.');
  }
  let key = keys.find((k) => S.orders[k].pickState !== 'done') || keys[0];
  try { await pkOpen(key, v, null); }
  catch (err) {
    beep('err'); flash('bad');
    pkMsg('e', 'Lỗi khi mở đơn: <b>' + esc(err && err.message || String(err)) + '</b>. Chụp màn hình gửi quản lý.');
    log('Lỗi pkOpen: ' + (err && err.message || err), 'er'); diagErr('pkOpen · mã ' + v, err); console.error(err);
  }
}

async function pkOpen(key, code, claimed) {
  const o = S.orders[key];
  if (!o) { pkMsg('e', 'Lỗi dữ liệu: không có đơn <b>' + esc(key) + '</b>.'); beep('err'); return; }
  let warn = null;
  if (o.pickState === 'done') {
    warn = {
      title: 'Đơn này đã nhặt rồi',
      body: '<b>' + esc(o.orderId) + '</b> đã hoàn thành lúc ' + esc(o.pickedAt ? new Date(o.pickedAt).toLocaleTimeString('vi-VN') : '—') +
        (o.pickedMay ? ' bởi <b>' + esc(o.pickedMay) + '</b>' : '') + '. Nhặt lại sẽ xóa kết quả cũ của đơn này.',
      redo: true
    };
  } else if (o.statusGroup === 'HUY') {
    warn = { title: 'Đơn đã hủy', body: '<b>' + esc(o.orderId) + '</b> có trạng thái <b>' + esc(o.statusRaw) + '</b>. Bình thường không cần nhặt.' };
  } else if (o.statusGroup === 'XONG') {
    warn = { title: 'Đơn đã xong', body: '<b>' + esc(o.orderId) + '</b> có trạng thái <b>' + esc(o.statusRaw) + '</b> — sàn ghi nhận đã giao xong.' };
  } else if (o.isReturn) {
    warn = { title: 'Đơn có yêu cầu trả hàng', body: '<b>' + esc(o.orderId) + '</b> đang có yêu cầu trả hàng hoặc hoàn tiền.' };
  }
  if (warn) {
    beep(warn.redo ? 'dup' : 'warn'); flash(warn.redo ? 'bad' : 'warn');
    const go = await dialog({ title: warn.title, body: warn.body, buttons: [{ label: 'Bỏ qua', val: false }, { label: warn.redo ? 'Nhặt lại' : 'Vẫn xử lý', val: true, cls: 'dang' }] });
    if (!go) { pkMsg('w', 'Đã bỏ qua đơn <b>' + esc(o.orderId) + '</b>.'); $('#pkScan').focus(); return; }
    if (warn.redo) {
      localResetPick(key);
      enqueue({ rpc: 'reset_pick', args: { p_order_pk: o.id }, key, label: 'nhặt lại ' + o.orderId });
    }
  }
  pk.cur = key; pk.batch = [key];
  if (!warn) pkMsg('');
  $('#pkOrdCard').style.display = '';
  popCard();
  renderBatch();
  pkRenderOrder();
  setTimeout(() => $('#pkBc').focus(), 60);
  saveDraft();

  // claim nền: máy khác đang mở đơn này? (không chặn quét)
  if (!claimed) {
    const seq = ++pk.claimSeq;
    rpc('claim_pick', { p_code: o.tracking || o.orderId }).then(({ data, ms }) => {
      if (seq !== pk.claimSeq || pk.cur !== key) return;
      handleClaim(data, ms, o);
    }).catch((e) => log('claim_pick: ' + e.message, 'wr'));
  } else handleClaim(claimed, 0, o);
}
/* --- gom đơn giống nhau: quét MVĐ thứ 2 khi đang mở đơn --- */
function pkAddToBatch(key, viaOid, claimed) {
  const rep = S.orders[pk.cur], o = S.orders[key];
  if (!o) return;
  if (pk.batch.includes(key)) {
    beep('dup'); flash('warn');
    pkMsg('w', 'Đơn <b>' + esc(o.orderId) + '</b> đã có trong nhóm đang nhặt.');
    $('#pkBc').focus(); return;
  }
  const why = o.pickState === 'done' ? 'đã nhặt rồi' : o.statusGroup === 'HUY' ? 'sàn đã hủy' : o.statusGroup === 'XONG' ? 'sàn báo đã xong'
    : o.isReturn ? 'có yêu cầu trả hàng' : o.statusGroup === 'KHAC' ? 'trạng thái chưa nhận diện' : '';
  if (why) {
    beep('warn'); flash('warn');
    pkMsg('w', 'Đơn <b>' + esc(o.orderId) + '</b> ' + why + ' — cần xử lý riêng. <b>Hoàn thành</b> hoặc <b>Bỏ qua</b> nhóm đang mở trước rồi quét lại.');
    $('#pkBc').focus(); return;
  }
  if (K.itemSignature(o) !== K.itemSignature(rep)) {
    beep('err'); flash('bad');
    pkMsg('e', '<b>Khác sản phẩm hoặc số lượng</b> — đơn <b>' + esc(o.orderId) + '</b> không gộp được với nhóm đang mở (' + esc(rep.orderId) + '). Hoàn thành hoặc Bỏ qua đơn đang mở trước.');
    $('#pkBc').focus(); return;
  }
  pk.batch.push(key);
  beep('ok'); flash('ok'); popCard();
  pkMsg('s', 'Đã gom <b>' + esc(o.orderId) + '</b>' + (viaOid ? ' (khớp theo mã đơn hàng)' : '') + ' — nhóm <b>' + pk.batch.length + '</b> đơn giống nhau. Nhặt một lần, Hoàn thành ghi cho cả nhóm.');
  renderBatch(); pkRenderOrder(); saveDraft();
  $('#pkBc').focus();
  if (claimed) handleClaim(claimed, 0, o);
  else rpc('claim_pick', { p_code: o.tracking || o.orderId }).then(({ data, ms }) => { if (pk.batch.includes(key)) handleClaim(data, ms, o); }).catch((e) => log('claim_pick: ' + e.message, 'wr'));
}
function renderBatch() {
  const box = $('#pkBatch');
  if (!pk.cur || pk.batch.length < 2) { box.style.display = 'none'; box.innerHTML = ''; $('#pkDone').textContent = 'Hoàn thành'; return; }
  box.style.display = '';
  box.innerHTML = '<span>Gom <b>' + pk.batch.length + '</b> đơn giống nhau:</span>' + pk.batch.map((k, i) => {
    const o = S.orders[k];
    return '<span class="bchip' + (i === 0 ? ' rep' : '') + '"><span class="chan ' + o.channel + '">' + o.channel + '</span>' + esc(o.orderId) +
      (i === 0 ? '' : '<button data-k="' + esc(k) + '" title="Bỏ đơn này khỏi nhóm">×</button>') + '</span>';
  }).join('');
  box.querySelectorAll('button').forEach((b) => { b.onclick = function () { pk.batch = pk.batch.filter((k) => k !== this.dataset.k); renderBatch(); pkRenderOrder(); saveDraft(); $('#pkBc').focus(); }; });
  $('#pkDone').textContent = 'Hoàn thành ' + pk.batch.length + ' đơn';
}
function popCard() {
  const c = $('#pkOrdCard'); c.classList.add('hi'); c.classList.remove('pop');
  void c.offsetWidth; c.classList.add('pop');
}

function handleClaim(d, ms, o) {
  if (!d || !d.found) return;
  if (d.claimedByOther) {
    beep('warn'); flash('warn');
    const ago = d.claimedAgoSec < 60 ? d.claimedAgoSec + ' giây' : Math.round(d.claimedAgoSec / 60) + ' phút';
    pkMsg('w', '<b>' + esc(d.claimedByOther) + '</b> đang mở đơn <b>' + esc(o.orderId) + '</b> từ ' + ago + ' trước. Hai máy cùng nhặt một đơn sẽ đè kết quả nhau — kiểm tra với máy kia trước.');
  }
  // máy chủ nói đã pick rồi mà RAM máy này chưa biết (realtime chưa tới)
  if (d.alreadyPicked && o.pickState !== 'done' && d.order && d.order.pickState === 'done') {
    beep('dup'); flash('warn');
    pkMsg('w', 'Máy chủ báo đơn <b>' + esc(o.orderId) + '</b> <b>đã được nhặt</b> bởi ' + esc(d.order.pickedMay || '?') + ' lúc ' + esc(new Date(d.order.pickedAt).toLocaleTimeString('vi-VN')) + '. Nếu vẫn nhặt, kết quả máy này sẽ đè.');
  }
}

/* --- nháp phòng đóng tab giữa chừng --- */
function saveDraft() {
  if (!pk.cur) { kvDel('draft').catch(() => { }); return; }
  const o = S.orders[pk.cur];
  kvSet('draft', { key: pk.cur, batch: pk.batch, items: o.items, at: Date.now() }).catch(() => { });
}
export async function restoreDraft() {
  try {
    const d = await kvGet('draft'); if (!d || !d.key) return;
    const o = S.orders[d.key];
    if (!o || o.pickState === 'done' || Date.now() - d.at > 12 * 3600e3) { kvDel('draft'); return; }
    o.items = d.items;
    log('Khôi phục đơn đang nhặt dở: ' + o.orderId, 'wr');
    pk.cur = d.key; pk.batch = (d.batch || [d.key]).filter((k) => S.orders[k] && S.orders[k].pickState !== 'done');
    if (!pk.batch.includes(d.key)) pk.batch.unshift(d.key);
    $('#pkOrdCard').style.display = ''; popCard(); renderBatch(); pkRenderOrder();
  } catch (e) { }
}

/* --- vẽ bảng chi tiết --- */
function pkRenderOrder() {
  const key = pk.cur; if (!key) return;
  const o = S.orders[key];
  const stG = o.statusGroup || 'KHAC';
  $('#pkOrdHead').innerHTML =
    '<span class="oid">' + esc(o.orderId) + '</span>' +
    '<span class="chan ' + o.channel + '">' + o.channel + '</span>' +
    '<span class="meta">' + esc(o.tracking || '') + '</span>' +
    '<span class="badge g-' + stG + '" title="' + esc(o.statusRaw) + '">' + esc(K.GROUPS[stG] || stG) + '</span>' +
    (o.isReturn ? '<span class="badge g-TRA">Trả hàng</span>' : '') +
    '<span class="meta" style="margin-left:auto">' + esc(o.carrier || '') + ' · ' + esc(o.statusRaw || '') + '</span>';

  const rows = ['<tr><th style="width:170px">Mã vạch</th><th>Sản phẩm</th><th style="width:70px">SL</th><th style="width:150px">Đã nhặt</th></tr>'];
  o.items.forEach((raw, ix) => {
    const it = itemView(raw);
    const cls = it.isSub ? 'sub' : (it.picked > it.qty ? 'over' : (it.picked >= it.qty && it.qty > 0 ? 'done' : (it.picked > 0 ? 'short' : '')));
    rows.push('<tr class="' + cls + '">' +
      '<td class="bc">' + (it.barcode ? esc(it.barcode) : '<span style="color:var(--bad)">thiếu mã vạch</span>') + '</td>' +
      '<td>' + (it.isSub ? '<input type="text" class="subname" data-ix="' + ix + '" placeholder="Nhập tên sản phẩm thay thế" value="' + esc(it.name || '') + '">' : esc(it.name)) + '</td>' +
      '<td class="n">' + it.qty + '</td>' +
      '<td><input type="text" class="qty" data-ix="' + ix + '" value="' + (it.picked || (it.picked === 0 && it.isSub) ? it.picked : '') + '" placeholder="—">' +
      ' <button class="tick" data-ix="' + ix + '" title="Xác nhận số lượng">✓</button></td></tr>');
  });
  $('#pkItems').innerHTML = rows.join('');
  $('#pkItems').querySelectorAll('input.qty').forEach((el) => {
    el.addEventListener('change', function () { pkSetQty(+this.dataset.ix, this.value); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); pkSetQty(+this.dataset.ix, this.value); $('#pkBc').focus(); } });
  });
  $('#pkItems').querySelectorAll('button.tick').forEach((el) => {
    el.onclick = function () { const ix = +this.dataset.ix; const inp = $('#pkItems').querySelector('input.qty[data-ix="' + ix + '"]'); pkSetQty(ix, inp.value); $('#pkBc').focus(); };
  });
  $('#pkItems').querySelectorAll('input.subname').forEach((el) => {
    el.addEventListener('change', function () { o.items[+this.dataset.ix].subName = K.norm(this.value); saveDraft(); });
  });

  const st = statOf(o), tags = [];
  $('#pkDone').disabled = !st.picked; $('#pkDone').title = st.picked ? '' : 'Chưa quét sản phẩm nào';
  if (!st.picked) tags.push('<span style="color:var(--ink3)">chưa quét sản phẩm nào</span>');
  if (st.short && st.picked) tags.push('<span style="color:var(--warn)">còn thiếu ' + st.missing + ' sản phẩm</span>');
  if (st.over) tags.push('<span style="color:var(--warn)">nhặt dư ' + st.overQty + '</span>');
  if (st.sub) tags.push('<span style="color:var(--info)">có sản phẩm thay thế</span>');
  if (!tags.length) tags.push('<span style="color:var(--ok)">đủ hàng</span>');
  $('#pkHint').innerHTML = tags.join(' · ');
}

function pkSetQty(ix, val) {
  const o = S.orders[pk.cur];
  let n = K.toInt(val); if (n < 0) n = 0;
  const before = o.items[ix].picked || 0;
  o.items[ix].picked = n;
  const it = itemView(o.items[ix]);
  if (!it.isSub && n > it.qty && before <= it.qty) {
    beep('warn'); flash('warn');
    pkMsg('w', 'Nhập <b>' + n + '</b> cho sản phẩm chỉ cần <b>' + it.qty + '</b> — dư <b>' + (n - it.qty) + '</b>. Kiểm tra lại trước khi hoàn thành.');
  }
  saveDraft(); pkRenderOrder();
}

/* --- quét mã vạch sản phẩm --- */
async function pkBarcode(v) {
  const key = pk.cur; if (!key) return;
  const o = S.orders[key];
  let hit = -1, any = -1;
  o.items.forEach((raw, ix) => {
    const it = itemView(raw);
    if ((it.barcode || '').toUpperCase() !== v) return;
    if (any < 0) any = ix;
    if (hit < 0 && it.picked < Math.max(it.qty, 1)) hit = ix;
  });
  if (hit < 0) hit = any;

  if (hit >= 0) {
    const it = itemView(o.items[hit]);
    if (it.isSub) { o.items[hit].picked = (it.picked || 0) + 1; beep('ok'); flash('ok'); }
    else if (it.picked >= it.qty && it.qty > 0) {
      beep('dup'); flash('warn');
      pkMsg('w', 'Sản phẩm này đã đủ <b>' + it.qty + '</b> rồi — mã vừa quét không được tính thêm.');
    } else { o.items[hit].picked = it.qty; beep('ok'); flash('ok'); }
    saveDraft(); pkRenderOrder();
    return;
  }

  beep('err'); flash('bad');
  let blank = -1;
  o.items.forEach((raw, ix) => { const it = itemView(raw); if (blank < 0 && !it.barcode && !it.isSub) blank = ix; });
  const btns = [{ label: 'Đóng', val: 'close' }];
  if (blank >= 0) btns.push({ label: 'Gán cho dòng thiếu mã vạch', val: 'assign' });
  btns.push({ label: 'Đổi sản phẩm', val: 'sub', cls: 'dang' });
  const act = await dialog({
    title: 'Sai sản phẩm',
    body: 'Mã vạch <b>' + esc(v) + '</b> không có trong đơn <b>' + esc(o.orderId) + '</b>.' +
      (blank >= 0 ? '<br><span style="color:var(--warn)">Đơn này có 1 dòng sàn không gắn mã vạch — có thể gán mã vừa quét cho dòng đó.</span>' : ''),
    buttons: btns
  });
  if (act === 'sub') {
    o.items.push({ barcode: v, barcodeSrc: '', name: '', qty: 0, picked: 1, isSub: true, subName: '' });
    saveDraft(); pkRenderOrder();
    setTimeout(() => { const el = $('#pkItems').querySelector('input.subname[data-ix="' + (o.items.length - 1) + '"]'); if (el) el.focus(); }, 60);
  } else if (act === 'assign') {
    o.items[blank].barcode = v;
    o.items[blank].picked = itemView(o.items[blank]).qty;
    beep('ok'); saveDraft(); pkRenderOrder(); $('#pkBc').focus();
  } else $('#pkBc').focus();
}

/* --- hoàn thành / bỏ qua --- */
async function pkDone() {
  const key = pk.cur; if (!key) return;
  const o = S.orders[key];
  const st = statOf(o);
  if (!st.picked) {
    beep('err'); flash('bad');
    pkMsg('e', 'Chưa quét sản phẩm nào cho đơn <b>' + esc(o.orderId) + '</b> — không hoàn thành được. Quét mã vạch từng sản phẩm, hoặc bấm <b>Bỏ qua</b> nếu muốn để đơn này làm sau.');
    $('#pkBc').focus(); return;
  }
  if (st.over) {
    const lines = [];
    o.items.forEach((raw) => { const it = itemView(raw); if (it.isSub || it.picked <= it.qty) return; lines.push('<li><b>' + esc(it.name || it.barcode || '(không rõ tên)') + '</b> — đơn cần ' + it.qty + ', đã nhặt <b style="color:var(--bad)">' + it.picked + '</b> (dư ' + (it.picked - it.qty) + ')</li>'); });
    beep('warn'); flash('warn');
    const okOver = await dialog({
      title: 'Nhặt dư so với đơn',
      body: 'Đơn <b>' + esc(o.orderId) + '</b> đang dư <b>' + st.overQty + ' sản phẩm</b>:<ul style="margin:10px 0 0;padding-left:20px">' + lines.join('') + '</ul><p style="margin:10px 0 0">Giao dư sẽ mất hàng mà sàn không trả tiền. Kiểm tra kỹ trước khi xác nhận.</p>',
      buttons: [{ label: 'Quay lại sửa', val: false }, { label: 'Xác nhận giao dư', val: true, cls: 'dang' }]
    });
    if (!okOver) { $('#pkBc').focus(); return; }
  }
  if (st.short) {
    beep('warn'); flash('warn');
    const ok = await dialog({
      title: 'Đơn còn thiếu hàng',
      body: 'Đơn <b>' + esc(o.orderId) + '</b> còn thiếu <b>' + st.missing + ' sản phẩm</b> so với đơn sàn. Xác nhận là thực sự thiếu, không phải quên quét?',
      buttons: [{ label: 'Quay lại quét tiếp', val: false }, { label: 'Xác nhận thiếu', val: true, cls: 'dang' }]
    });
    if (!ok) { $('#pkBc').focus(); return; }
  }
  const note = [];
  if (st.short) note.push('thiếu ' + st.missing);
  if (st.over) note.push('dư ' + st.overQty);
  if (st.sub) note.push('có thay thế');
  const noteStr = note.join(', ');

  // RAM trước, máy chủ sau (hàng đợi nền). Nhóm gom: sao chép items đại diện sang từng đơn.
  const items = o.items.map((it) => it.isSub
    ? { isSub: true, barcode: it.barcode, picked: it.picked || 0, subName: it.subName || it.name || '' }
    : { idx: it.idx, barcode: it.barcode, picked: it.picked || 0 });
  const group = pk.batch.length ? pk.batch.slice() : [key];
  const t = stamp();
  group.forEach((k) => {
    if (k !== key) S.orders[k].items = structuredClone(o.items);
    localFinishPick(k, noteStr);
    pk.hist.unshift({ id: S.orders[k].orderId, chan: S.orders[k].channel, note: noteStr + (group.length > 1 ? (noteStr ? ', ' : '') + 'gom ' + group.length : ''), t });
  });
  pk.hist = pk.hist.slice(0, 8);
  if (group.length > 1) {
    enqueue({ rpc: 'finish_pick_batch', args: { p_order_pks: group.map((k) => S.orders[k].id), p_items: items, p_note: noteStr }, key, keys: group, label: 'pick gom ' + group.length + ' đơn' });
  } else {
    enqueue({ rpc: 'finish_pick', args: { p_order_pk: o.id, p_items: items, p_note: noteStr }, key, label: 'pick ' + o.orderId });
  }

  beep('done'); flash('ok');
  pkRenderHist();
  pkClose();
  pkMsg('s', (group.length > 1 ? 'Đã nhặt xong <b>' + group.length + ' đơn</b> giống nhau (' + group.map((k) => esc(S.orders[k].orderId)).join(', ') + ')' : 'Đã nhặt xong <b>' + esc(o.orderId) + '</b>') +
    (noteStr ? ' (' + esc(noteStr) + ')' : '') + '. Quét mã vận đơn tiếp theo.');
}
function pkSkip() {
  const key = pk.cur; if (!key) return;
  const o = S.orders[key];
  const group = pk.batch.length ? pk.batch.slice() : [key];
  group.forEach((k) => localResetPick(k));
  pkClose();
  pkMsg('w', 'Đã bỏ qua <b>' + (group.length > 1 ? group.length + ' đơn' : esc(o.orderId)) + '</b>, dữ liệu vừa nhập đã xóa.');
}
function pkClose() {
  pk.cur = null; pk.batch = []; pk.claimSeq++;
  $('#pkOrdCard').style.display = 'none'; $('#pkOrdCard').classList.remove('hi', 'pop');
  renderBatch();
  kvDel('draft').catch(() => { });
  pkRefresh();
  setTimeout(() => $('#pkScan').focus(), 60);
}
function pkRenderHist() {
  $('#pkHistCard').style.display = pk.hist.length ? '' : 'none';
  $('#pkHist').innerHTML = pk.hist.map((h) => '<div class="' + (h.note ? 'warn' : '') + '"><span>' + h.t + '</span><span>' + esc(h.id) + '</span><span class="chan ' + h.chan + '">' + h.chan + '</span>' + (h.note ? '<span style="color:var(--warn)">' + esc(h.note) + '</span>' : '') + '</div>').join('');
}

/* Realtime báo đơn đang mở vừa bị máy khác đổi */
export function pkExternalChange(key, o) {
  if (!pkOpenKeys().includes(key)) { if ($('#v2').classList.contains('sel')) pkRefresh(); return; }
  if (o && o.pickState === 'done') {
    beep('warn'); flash('warn');
    pkMsg('w', '<b>' + esc(o.pickedMay || 'Máy khác') + '</b> vừa hoàn thành đơn <b>' + esc(o.orderId) + '</b> đang mở trên máy này. Bấm Bỏ qua nếu không cần nhặt nữa.');
  }
}
